import { render, staticRenderFns } from "./reviewBox.vue?vue&type=template&id=255a6006&scoped=true&"
import script from "./reviewBox.vue?vue&type=script&lang=js&"
export * from "./reviewBox.vue?vue&type=script&lang=js&"
import style0 from "./reviewBox.vue?vue&type=style&index=0&id=255a6006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a6006",
  null
  
)

export default component.exports